import { eAccessControlUserType } from '../../ui-toolkit/enums/eAccessControlUserType';
import { clientUrls } from '../../ui-toolkit/rest/ClientUrlFactory';

const homeLinks: Record<eAccessControlUserType, string> = {
  [eAccessControlUserType.Admin]: clientUrls.urlFor.adminOrders(),
  [eAccessControlUserType.Client]: clientUrls.urlFor.clientOrders(),
  [eAccessControlUserType.Vendor]: clientUrls.urlFor.vendorOrders(),
  [eAccessControlUserType.None]: '',
};

export const getDefaultHomeLinkForUserType = (userType: eAccessControlUserType): string => {
  return homeLinks[userType];
};
